export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const isQuarterlyData = indicatorCode => {
  const list = [
    'NetIncome',
    'GrossProfit',
    'GrossProfitMargin',
    'NetProfit',
    'NetProfitMargin',
    'NetRevenue',
    'ROA',
    'ROE',
    'TotalAsset',
    'TotalLiabilities',
    'CurrentAsset',
    'CurrentLiabilities',
    'Equity',
    'EBITMargin',
    'TotalLoans',
    'TotalDeposit',
  ];

  return list.includes(indicatorCode);
};

export const drawImageToCanvas = (ctx, content, dy) =>
  new Promise(resolve => {
    const image = new Image();
    image.onload = () => {
      ctx.drawImage(image, 0, dy);
      resolve(true);
    };
    image.src = content;
  });

export const getImage = data => {
  const width = data[0].contentWidth;
  const imageData = data.reduce(
    (result, item) => {
      return {
        height: result.height + item.contentHeight,
        items: result.items.concat({
          ...item,
          dy: result.height,
        }),
      };
    },
    { height: 0, items: [] },
  );
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext('2d');
  const promises = imageData.items.map(item =>
    drawImageToCanvas(ctx, item.content, item.dy),
  );
  return Promise.all(promises).then(() => canvas.toDataURL('image/jpeg'));
};

export const takeScreenShot = widget =>
  new Promise(resolve => {
    widget.showSaveAsChartDialog();
    widget.takeScreenshot();
    const onScreenShotReady = async data => {
      widget.showSaveAsChartDialog();
      resolve(await getImage(data.result));
      widget.unsubscribe('onScreenshotReady', onScreenShotReady);
    };
    widget.subscribe('onScreenshotReady', onScreenShotReady);
  });
